var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_769_17375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_769_17375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 13.4749L7.17511 18.2999C6.97511 18.4999 6.73344 18.5957 6.45011 18.5874C6.16678 18.5791 5.92511 18.4749 5.72511 18.2749C5.52511 18.0749 5.42511 17.8291 5.42511 17.5374C5.42511 17.2457 5.52511 16.9999 5.72511 16.7999L10.5251 11.9999L5.70011 7.1749C5.50011 6.9749 5.40428 6.72907 5.41261 6.4374C5.42094 6.14574 5.52511 5.8999 5.72511 5.6999C5.92511 5.4999 6.17094 5.3999 6.46261 5.3999C6.75428 5.3999 7.00011 5.4999 7.20011 5.6999L12.0001 10.5249L16.8251 5.6999C17.0251 5.4999 17.2709 5.3999 17.5626 5.3999C17.8543 5.3999 18.1001 5.4999 18.3001 5.6999C18.5001 5.8999 18.6001 6.14574 18.6001 6.4374C18.6001 6.72907 18.5001 6.9749 18.3001 7.1749L13.4751 11.9999L18.3001 16.8249C18.5001 17.0249 18.6001 17.2666 18.6001 17.5499C18.6001 17.8332 18.5001 18.0749 18.3001 18.2749C18.1001 18.4749 17.8543 18.5749 17.5626 18.5749C17.2709 18.5749 17.0251 18.4749 16.8251 18.2749L12.0001 13.4749Z",
    fill: "#D3135A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/CloseModal.ad4cffd5b935840bd7faba3927944713.svg";
export { ForwardRef as ReactComponent };